import React, { useEffect, useRef, useState } from "react";
import { Link, navigate, useNavigate } from "react-router-dom";
import {
  Card,
  Col,
  Container,
  Nav,
  Navbar,
  Button,
  Form,
  Modal,
  Row,
  Table,
  Spinner,
} from "react-bootstrap";
import logo1 from "../Assets/logonew.png";
import "../Admin/AdminMaster/AdminBilling.css";
import "./Master.css";
import Dropdown from "react-bootstrap/Dropdown";
import axios from "axios";
import { toast } from "react-toastify";
import { Autocomplete, InputLabel, TextField } from "@mui/material";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import {
  BillingFindAll,
  CustomerFindAll,
  Customerviewbilldata,
  DeliveryAllInnerData,
  EmployeeFindAll,
  Employeeviewbilldata,
  GeneratebillApi,
  GeneratebillApi2,
  InnerTableDataCustomer,
  InnerTableDataEmployee,
  ProductFindAll,
  SelectAllData,
} from "../Admin/API/Api";
import dayjs from "dayjs";
import Box from "@mui/material/Box";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import html2pdf from "html2pdf.js";
import { saveAs } from "file-saver";
import { useReactToPrint } from "react-to-print";
import AdminNavBar from "./AdminNavBar";
import NavLogo from "./NavLogo";
import { MDBDataTable } from "mdbreact";

const BillingProcess1 = () => {
  const selectedLanguage = sessionStorage.getItem("selectedLanguage");
  const userdata = JSON.parse(sessionStorage.getItem("userdata"));
  const branchId = userdata.branch_id;
  const Name = userdata ? userdata.branch_name : "";

  const [orderData, setOrderData] = useState([]);
  const [orderDataInner, setOrderDataInner] = useState([]);
  const [employee_master, setEmployee_master] = useState([]);
  const [customer_master, setCustomer_master] = useState([]);
  const [product_master, setProduct_master] = useState([]);
  const [employeeId, setEmployeeId] = useState("");
  const [customerId, setCustomerId] = useState("");
  const [date, setDate] = useState(dayjs());
  const [toDate, setToDate] = useState(null);
  const [selectedOption, setSelectedOption] = useState("");
  const [groupedData, setGroupedData] = useState([]);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [dataShown, setDataShown] = useState(false);

  const BrName = userdata.branch_name;

  const handleClose = () => setShow(false);
  const [show, setShow] = useState(false);

  const handleClose1 = () => setShow1(false);
  const [show1, setShow1] = useState(false);

  const [selectedMonth, setSelectedMonth] = useState("");

  const handleMonthChange = (event) => {
    setSelectedMonth(event.target.value);
  };

  const navigate = useNavigate();

  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());

  const handleYearChange = (event) => {
    setSelectedYear(event.target.value);
  };

  const calculateTotalQuantity = (data) => {
    return data.reduce((total, item) => total + item.quantity, 0);
  };
  const calculateTotalQuantity1 = (orderDataInner) => {
    let totalQuantity = 0;
    orderDataInner.forEach((item) => {
      totalQuantity += item.quantity;
    });
    return totalQuantity;
  };
  // Group the data based on customer_id
  const groupedData1 = orderData.reduce((acc, item) => {
    const {
      customer_id,
      customer_name,
      employee_name,
      productdetails,
      quantity,
      rate,
      total,
      product,
      employee_id,
    } = item;

    if (!acc[customer_id]) {
      acc[customer_id] = {
        customer_id,
        customer_name,
        employee_name,
        items: [],
      };
    }

    acc[customer_id].items.push({
      product,
      productdetails,
      quantity,
      rate,
      total,
      employee_name,
      employee_id,
    });

    return acc;
  }, {});

  // Convert the groupedData object to an array
  const groupedArray = Object.values(groupedData);
  const groupedArray1 = Object.values(groupedData1);

  const GetOrderdata = () => {
    const formattedDate = dayjs(date).format("YYYY-MM-DD");
    const formattedDate1 = dayjs(toDate).format("DD-MM-YYYY");

    if (selectedOption === "employee") {
      if (!date || !employeeId || !selectedYear || !selectedMonth) {
        toast.error("Please select all fields....");
        return;
      }
      console.log(
        "api console...",
        `${Employeeviewbilldata}/${employeeId}/${selectedMonth}/${selectedYear}/${formattedDate}/${branchId}`
      );
      axios
        .get(
          `${Employeeviewbilldata}/${employeeId}/${selectedMonth}/${selectedYear}/${formattedDate}/${branchId}`
        )
        .then((res) => {
          console.log("responseeee===>>>>", res.data);

          if (res.data === "NOTFOUND") {
            toast.warn("Data Not Allocated !!!");
          } else if (res.data !== null) {
            setCustomerId(res.data.customer_id);
            setOrderData(res.data);
            setDataShown(true);
          } else if (res.data.length === 0) {
            toast.warn("Employee Not Allocated...");
          }
        })
        .catch((err) => {
          toast.error("Failed to fetch data. Please try again.");
          console.error(err);
        });
    } else if (selectedOption === "customer") {
      if (!date || !customerId || !selectedYear || !selectedMonth) {
        toast.error("Please select all fields....");
        return;
      }
      console.log(
        "api...",
        `${Customerviewbilldata}/${customerId}/${selectedMonth}/${selectedYear}/${formattedDate}/${branchId}`
      );
      axios
        .get(
          `${Customerviewbilldata}/${customerId}/${selectedMonth}/${selectedYear}/${formattedDate}/${branchId}`
        )
        .then((res) => {
          console.log("cust api...", res.data);
          if (res.data === "NOTFOUND") {
            toast.warn("Data Not Billing...");
          } else if (res.data !== null) {
            setEmployeeId(res.data.employee_id);
            setOrderData(res.data);
            setDataShown(true);
          } else if (res.data.length === 0) {
            toast.warn("Customer Not Allocated...");
          }
        })
        .catch((err) => {
          toast.error("Failed to fetch data. Please try again.");
          console.error(err);
        });
    } else if (selectedOption === "all") {
      if (!date || !selectedYear || !selectedMonth) {
        toast.error("Please select all fields.");
        return;
      }
      axios
        .get(
          `${SelectAllData}/${selectedMonth}/${selectedYear}/${formattedDate}/${branchId}`
        )
        .then((res) => {
          if (res.data === "NOTFOUND") {
            toast.warn("Data Not Billing...");
          } else if (res.data !== null) {
            setOrderData(res.data);
          } else if (res.data.length === 0) {
            toast.warn("Data Are Not Billing...");
          }
        })
        .catch((err) => {
          toast.error("Failed to fetch data. Please try again.");
          console.error(err);
        });
    } else {
      toast.error("Please select all fields.");
    }
  };

  // =============== inner table data ======================
  const handleShow = (group) => {
    console.log("groupdata grouping......", group);
    console.log("Customer is -----", group.customer_id);
    setShow(true);
    const formattedDate = dayjs(date).format("YYYY-MM-DD");
    const formattedDate1 = dayjs(toDate).format("DD-MM-YYYY");

    if (selectedOption === "employee") {
      console.log(
        "billing....",
        `${InnerTableDataCustomer}/${group.customer_id}/${selectedMonth}/${selectedYear}/${formattedDate}/${branchId}`
      );
      console.log("Customer is -----", group.customer_id);
      axios
        .get(
          `${InnerTableDataCustomer}/${group.customer_id}/${selectedMonth}/${selectedYear}/${formattedDate}/${branchId}`
        )
        .then((res) => {
          console.log("billing res", res.data);
          if (res.data.length === 0) {
            toast.warn("Customer Not Allocated...");
          } else if (res.data !== null) {
            setOrderDataInner(res.data);
          }
        })
        .catch((err) => {
          toast.error("Failed to fetch data. Please try again.");
          console.error(err);
        });
    } else if (selectedOption === "customer") {
      console.log(
        "billing....",
        `${InnerTableDataEmployee}/${group.customer_id}/${selectedMonth}/${selectedYear}/${formattedDate}/${branchId}`
      );
      console.log("Employeeid is -----", group.customer_id);
      axios
        .get(
          `${InnerTableDataEmployee}/${group.customer_id}/${selectedMonth}/${selectedYear}/${formattedDate}/${branchId}`
        )
        .then((res) => {
          console.log("billing res", res.data);
          if (res.data === "NOTFOUND") {
            toast.warn("Data Not Allocated...");
          } else if (res.data !== null) {
            console.log("inner data all console.....", res.data);
            setOrderDataInner(res.data);
          } else if (res.data.length === 0) {
            toast.warn("Customer Not Allocated...");
          }
        })
        .catch((err) => {
          toast.error("Failed to fetch data. Please try again.");
          console.error(err);
        });
    } else if (selectedOption === "all") {
      console.log(
        "billing....",
        `${DeliveryAllInnerData}/${selectedMonth}/${selectedYear}/${group[0].customer_id}/${branchId}`
      );
      axios
        .get(
          `${DeliveryAllInnerData}/${selectedMonth}/${selectedYear}/${group[0].customer_id}/${branchId}`
        )
        .then((res) => {
          console.log("billing res", res.data);
          if (res.data.length === 0) {
            toast.warn("Data Not Biling...");
          } else if (res.data !== null) {
            console.log("res.data.=== = = =  ", res.data);
            setOrderDataInner(res.data);
          }
        })
        .catch((err) => {
          toast.error("Failed to fetch data. Please try again.");
          console.error(err);
        });
    }
  };

  // ========================= Bill Generate  =====================
  function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }
  const generatePDF = async () => {
    setLoading(true);
    // Get the element you want to convert to PDF

    console.log("id cust console.....,,,,", customerId);
    console.log("id emp console.....,,,,", employeeId);

    const formattedDate = dayjs(date).format("YYYY-MM-DD");
    const requestData = {
      flag: selectedOption === "customer" ? 3 : 2,
      month: selectedMonth,
      year: selectedYear,
      bill_date: formattedDate,
      branch_id: branchId,
      ...(selectedOption === "customer"
        ? { customer_id: customerId }
        : { employee_id: employeeId }),
    };

    console.log("api log con,...", requestData);

    axios
      .post(GeneratebillApi, requestData)
      .then(async (response) => {
        console.log("Response:", response.data);
        if (response.data.message === "SAVED") {
          setData(response.data.data);

          const element = document.getElementById("pdf-content");
          const options = {
            filename: "generated.pdf",
            image: { type: "jpeg", quality: 0.98 },
            html2canvas: { scale: 2 },
            jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
          };

          element.style.display = "block";
          await sleep(4000); // Wait for 6 seconds (6000 milliseconds)
          html2pdf()
            .set(options)
            .from(element)
            .toPdf()
            .get("pdf")
            .then(function (pdf) {
              const blobUrl = URL.createObjectURL(pdf.output("blob"));
              element.style.display = "none";
              window.open(blobUrl, "_blank");
              setLoading(false);
            });
          toast.success("Bill saved successfully.");
        } else if (response.data === "ALREADYEXIST") {
          toast.warn("Bill already exists....");
          navigate("/billingProcess1");
          setLoading(false);
        } else if (response.data === "NOTFOUND") {
          toast.warn("Data Not Found....");
          navigate("/billingProcess1");
          setLoading(false);
        } else {
          console.log("Unexpected response:", response.data);
          setLoading(false);
        }
      })
      .catch((error) => {
        console.error("Failed to generate bill:", error);
        toast.error("Failed to generate bill, please try again.");
        setLoading(false);
      });
  };

  const generatePDFFromContent = () => {
    const element = document.getElementById("pdf-content");
    if (!element) {
      console.error('Element with id "pdf-content" not found.');
      setLoading(false);
      return;
    }

    const options = {
      filename: "generated.pdf",
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
    };

    element.style.display = "block";
    html2pdf()
      .set(options)
      .from(element)
      .toPdf()
      .get("pdf")
      .then(function (pdf) {
        const pdfName = `generated_${Date.now()}.pdf`;
        const blobUrl = URL.createObjectURL(pdf.output("blob"));
        window.open(blobUrl, "_blank");
        element.style.display = "none";
        setLoading(false);
      })
      .catch((error) => {
        console.error("Failed to generate PDF:", error);
        element.style.display = "none";
        setLoading(false);
      });
  };

  let isBillingProcessFetched = false
  useEffect(() => {
    if (isBillingProcessFetched) return
    setEmployeeId("");
    setCustomerId("");
    setToDate("");
    setDate("");
    setOrderData([]);

    setOrderDataInner([]);
    const fetchData = async () => {
      try {
        const [employeeRes, customerRes, productRes] = await Promise.all([
          axios.get(`${EmployeeFindAll}/${branchId}`),
          axios.get(`${CustomerFindAll}/${branchId}`),
          axios.get(`${ProductFindAll}/${branchId}`),
        ]);

        if (employeeRes.data !== null) {
          setEmployee_master(employeeRes.data);
        }

        if (customerRes.data !== null) {
          setCustomer_master(customerRes.data);
        }

        if (productRes.data !== null) {
          setProduct_master(productRes.data);
        }
      } catch (error) {
        console.error("Failed to fetch initial data.", error);
      }
    };

    fetchData();

    isBillingProcessFetched = true
  }, []);

  const calculateGrandTotal = (orderData) => {
    // Use reduce to sum up the 'total' values of each item in orderData
    const grandTotal = orderData.reduce((acc, item) => acc + item.total, 0);

    // Check if grandTotal has decimal places
    const formattedGrandTotal = Number.isInteger(grandTotal)
      ? grandTotal.toFixed(0)
      : grandTotal.toFixed(2);

    return formattedGrandTotal; // Return the formatted grand total
  };

  // ---------------print-----
  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: "Payment_Recipt",
    // onAfterPrint: () => alert('Print Success')
  });

  const pdfOptions = {
    margin: 10,
    filename: "Payment_Recipt.pdf",
    image: { type: "jpeg", quality: 0.98 },
    html2canvas: { scale: 2 },
    jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
    pagebreak: { before: ".page-break" }, // Use this class to force page breaks
  };

  // Select the content to print (excluding buttons)
  const contentToPrint = document.getElementById("content-to-print");

  // Generate the PDF
  html2pdf()
    .from(contentToPrint)
    .set(pdfOptions)
    .outputPdf((pdf) => {
      // Save the PDF to the user's PC
      saveAs(pdf, "Payment_Recipt.pdf");
    });

  // ===================== all data table ===================
  useEffect(() => {
    // Group the data based on customer and employee
    const groupedArray = groupDataByCustomerAndEmployee(orderData);
    setGroupedData(groupedArray);
  }, [orderData]);

  const groupDataByCustomerAndEmployee = (data) => {
    const groupedByCustomerAndEmployee = {};

    data.forEach((item) => {
      const customerName = item.customer_name;
      const employeeName = item.employee_name;

      if (!groupedByCustomerAndEmployee[customerName]) {
        groupedByCustomerAndEmployee[customerName] = {};
      }

      if (!groupedByCustomerAndEmployee[customerName][employeeName]) {
        groupedByCustomerAndEmployee[customerName][employeeName] = [];
      }

      groupedByCustomerAndEmployee[customerName][employeeName].push(item);
    });

    return groupedByCustomerAndEmployee;
  };
  // ========== inner table grand taotal =====================
  const [grandTotal, setGrandTotal] = useState(0);

  // Function to calculate the grand total
  const calculateGrandTotal1 = (orderDataInner) => {
    let total = 0;
    orderDataInner.forEach((item) => {
      total += item.rate * item.quantity;
    });
    return total;
  };

  // This useEffect hook will recalculate the grand total whenever orderDataInner changes
  useEffect(() => {
    setGrandTotal(calculateGrandTotal1(orderDataInner));
  }, [orderDataInner]);

  return (
    <div>
      <AdminNavBar />
      <section className="home-section">
        <NavLogo />

        <Row className="m-0 p-0 pt-5 px-md-4 px-2">
          <Col
            className=" rounded text-center pt-2"
            style={{
              display: "flex",
              justifyContent: "start",
              backgroundColor: "white",
              border: "0px",
              alignItems: "center",
              alignContent: "center",
              color: " rgb(47, 79, 79)",
            }}
          >

            <h5>{selectedLanguage === 'Marathi' ? 'बिलिंग प्रक्रिया' : 'BILLING PROCESS'}</h5>
          </Col>
        </Row>

        {/* ========================== BILLING PROCESS =========================== */}
        <Row className="m-0  py-3 px-2 mx-md-3   rounded">
          <Col className="m-0 p-0 py-3 rounded" style={{ background: "white" }}>
            <Row className="m-0 p-0">
              <Col sm={12} md={2} className="mt-3 ">
                <TextField
                  id="demo-simple-select"
                  size="small"
                  label={selectedLanguage === 'Marathi' ? 'पर्याय निवडा' : 'Select Option'}
                  select
                  value={selectedOption}
                  onChange={(e) => setSelectedOption(e.target.value)}
                  variant="outlined"
                  fullWidth
                  SelectProps={{
                    native: true,
                  }}
                >
                  <option value="" disabled></option>
                  {/* <option value="all">All</option> */}
                  <option value="employee">{selectedLanguage === 'Marathi' ? 'कर्मचारी' : 'Employee'}</option>
                  <option value="customer">{selectedLanguage === 'Marathi' ? 'ग्राहक' : 'Customer'}</option>
                </TextField>
              </Col>
              <Col sm={12} md={2} className="mt-3">
                {selectedOption && (
                  <>
                    {selectedOption === "employee" && (
                      <>
                        {/* <Form.Label><h6><b>Employee :</b></h6></Form.Label> */}
                        <Autocomplete
                          disablePortal
                          id="combo-box-demo"
                          size="small"
                          style={{ width: "100%" }}
                          options={employee_master}
                          getOptionLabel={(option) => option.name}
                          value={
                            employee_master.find(
                              (item) => item.employee_id === employeeId
                            ) || null
                          }
                          onChange={(e, newValue) =>
                            setEmployeeId(newValue ? newValue.employee_id : "")
                          }
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              size="small"
                              label={selectedLanguage === 'Marathi' ? 'कर्मचारी निवडा' : 'Select Employee'}
                            />
                          )}
                        />
                      </>
                    )}
                    {selectedOption === "customer" && (
                      <>
                        {/* <Form.Label><h6><b>Customer :</b></h6></Form.Label> */}
                        <Autocomplete
                          size="small"
                          disablePortal
                          id="combo-box-demo"
                          style={{ width: "100%" }}
                          options={customer_master}
                          getOptionLabel={(option) => option.customer_name}
                          value={
                            customer_master.find(
                              (item) => item.customer_id === customerId
                            ) || null
                          }
                          onChange={(e, newValue) =>
                            setCustomerId(newValue ? newValue.customer_id : "")
                          }
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              size="small"
                              label={selectedLanguage === 'Marathi' ? 'ग्राहक निवडा' : 'Select Customer'}
                            />
                          )}
                        />
                      </>
                    )}
                  </>
                )}
              </Col>
            </Row>

            <Row className="m-0 p-0 mt-md-3 mt-0">
              <Col
                sm={12}
                md={2}
                className="mt-3"
                style={{ display: "flex", flexDirection: "column" }}
              >
                <TextField
                  id="month-input"
                  size="small"
                  label={selectedLanguage === 'Marathi' ? 'महिना निवडा' : 'Select Month'}
                  select
                  value={selectedMonth}
                  onChange={handleMonthChange}
                  variant="outlined"
                  fullWidth
                  SelectProps={{
                    native: true,
                  }}
                >
                  <option value="" disabled></option>
                  <option value={1}>{selectedLanguage === 'Marathi' ? 'जानेवारी' : 'January'}</option>
                  <option value={2}>{selectedLanguage === 'Marathi' ? 'फेब्रुवारी' : 'February'}</option>
                  <option value={3}>{selectedLanguage === 'Marathi' ? 'मार्च' : 'March'}</option>
                  <option value={4}>{selectedLanguage === 'Marathi' ? 'एप्रिल' : 'April'}</option>
                  <option value={5}>{selectedLanguage === 'Marathi' ? 'मे' : 'May'}</option>
                  <option value={6}>{selectedLanguage === 'Marathi' ? 'जून' : 'June'}</option>
                  <option value={7}>{selectedLanguage === 'Marathi' ? 'जुलै' : 'July'}</option>
                  <option value={8}>{selectedLanguage === 'Marathi' ? 'ऑगस्ट' : 'August'}</option>
                  <option value={9}>{selectedLanguage === 'Marathi' ? 'सप्टेंबर' : 'September'}</option>
                  <option value={10}>{selectedLanguage === 'Marathi' ? 'ऑक्टोबर' : 'October'}</option>
                  <option value={11}>{selectedLanguage === 'Marathi' ? 'नोव्हेंबर' : 'November'}</option>
                  <option value={12}>{selectedLanguage === 'Marathi' ? 'डिसेंबर' : 'December'}</option>
                </TextField>
              </Col>

              <Col
                sm={12}
                md={2}
                className="mt-3"
                style={{ display: "flex", flexDirection: "column" }}
              >
                <FormControl fullWidth variant="outlined">
                  <InputLabel id="year-input-label">{selectedLanguage === 'Marathi' ? 'वर्ष निवडा' : 'Select Year'}</InputLabel>
                  <Select
                    labelId="year-input-label"
                    id="year-input"
                    size="small"
                    value={selectedYear}
                    onChange={handleYearChange}
                    label={selectedLanguage === 'Marathi' ? 'वर्ष निवडा' : 'Select Year'}
                  >
                    {/* You can customize the range of years as needed */}
                    {Array.from({ length: 10 }, (_, index) => {
                      const year = new Date().getFullYear() - index;
                      return (
                        <MenuItem key={year} value={year}>
                          {year}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
              </Col>

              <Col
                sm={12}
                md={3}
                className=" mt-2"
                style={{ display: "flex", flexDirection: "column" }}
              >
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DemoContainer components={["DatePicker"]}>
                    <DatePicker
                      format="DD-MM-YYYY"
                      label={selectedLanguage === 'Marathi' ? 'तारीख निवडा' : 'Select DateCustomer'}
                      value={date}
                      style={{ width: "100%" }}
                      onChange={(newDate) => {
                        console.log("date res", newDate);
                        setDate(newDate);
                      }}
                      slotProps={{ textField: { size: "small" } }}
                    />
                  </DemoContainer>
                </LocalizationProvider>
              </Col>

              <Col
                className="mt-2"
                style={{ display: "flex", flexDirection: "column" }}
              >
                <Col style={{ display: "flex", justifyContent: "start" }}>
                  <Button
                    style={{
                      backgroundColor: "rgb(47, 79, 79)",
                      borderRadius: "15px",
                      border: "0px",
                    }}
                    className="buttonAll py-2 px-3 mx-2 my-2 shadow text-light"
                    type="submit"
                    onClick={GetOrderdata}
                  >
                    {selectedLanguage === 'Marathi' ? 'माहिती बघा' : 'Show Data'}
                  </Button>
                </Col>
              </Col>
            </Row>
          </Col>
        </Row>

        {/* --------------------- All data table ----------- */}

        <Row className="m-0  py-1 px-2 mx-md-3   rounded">
          <Col
            className="m-0 p-0 pb-2 pt-3 px-3 rounded"
            style={{ background: "white" }}
          >
            {selectedOption === "all" ? (
              <div style={{ overflowY: "auto" }}>
                <div style={{ overflowX: "auto" }}>
                  <Table striped bordered hover size="sm" className=" mt-2">
                    <thead style={{ textAlign: "center" }}>
                      <tr>
                        <th
                          style={{
                            alignItems: "center",
                            backgroundColor: "darkslategray",
                            fontSize: "13px",
                            fontFamily: "sans-serif",
                          }}
                          className="text-center text-light"
                        >
                          {selectedLanguage === 'Marathi' ? 'अनु.क्र.' : 'Sr.No'}
                        </th>
                        <th
                          style={{
                            alignItems: "center",
                            backgroundColor: "darkslategray",
                            fontSize: "13px",
                            fontFamily: "sans-serif",
                          }}
                          className="text-center text-light"
                        >
                          {selectedLanguage === 'Marathi' ? 'ग्राहकाचे नाव' : 'Customer Name'}
                        </th>
                        <th
                          style={{
                            alignItems: "center",
                            backgroundColor: "darkslategray",
                            fontSize: "13px",
                            fontFamily: "sans-serif",
                          }}
                          className="text-center text-light"
                        >
                          {selectedLanguage === 'Marathi' ? 'कर्मचारी नाव' : 'Employee Name'}
                        </th>
                        <th
                          style={{
                            alignItems: "center",
                            backgroundColor: "darkslategray",
                            fontSize: "13px",
                            fontFamily: "sans-serif",
                          }}
                          className="text-center text-light"
                        >
                           {selectedLanguage === 'Marathi' ? 'वितरण तपशील' : 'Delivery Detail'}
                        </th>
                        <th
                          style={{
                            alignItems: "center",
                            backgroundColor: "darkslategray",
                            fontSize: "13px",
                            fontFamily: "sans-serif",
                          }}
                          className="text-center text-light"
                        >
                           {selectedLanguage === 'Marathi' ? 'एकूण रक्कम' : 'Total Amount '}
                        </th>
                        <th
                          style={{
                            alignItems: "center",
                            backgroundColor: "darkslategray",
                            fontSize: "13px",
                            fontFamily: "sans-serif",
                          }}
                          className="text-center text-light"
                        >
                           {selectedLanguage === 'Marathi' ? 'तपशील' : 'Detail'}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {Object.keys(groupedData).map(
                        (customerName, customerIndex) =>
                          Object.keys(groupedData[customerName]).map(
                            (employeeName, employeeIndex) => (
                              <tr key={`${customerIndex}-${employeeIndex}`}>
                                <td style={{ textAlign: "center" }}>
                                  {customerIndex + 1}
                                </td>
                                <td style={{ textAlign: "center" }}>
                                  {customerName}
                                </td>
                                <td style={{ textAlign: "center" }}>
                                  {employeeName}
                                </td>
                                <td style={{ textAlign: "center" }}>
                                  {groupedData[customerName][employeeName].map(
                                    (item, itemIndex) => (
                                      <div key={itemIndex}>
                                        {`${item.product} - Rs(${item.rate})- ${item.quantity}`}
                                      </div>
                                    )
                                  )}
                                </td>
                                <td
                                  className="pe-4"
                                  style={{ textAlign: "end" }}
                                >
                                  {groupedData[customerName][
                                    employeeName
                                  ].reduce(
                                    (sum, item) => sum + parseInt(item.total),
                                    0
                                  )}
                                </td>
                                <td
                                  style={{ textAlign: "center" }}
                                  onClick={() =>
                                    handleShow(
                                      groupedData[customerName][employeeName]
                                    )
                                  }
                                >
                                  <i className="fa-solid fa-circle-info"></i>
                                </td>
                              </tr>
                            )
                          )
                      )}
                    </tbody>
                    <tfoot>
                      <tr>
                        <td
                          style={{ textAlign: "center", color: "white" }}
                          colSpan="4"
                        ></td>
                        <td
                          className="pe-4"
                          style={{ textAlign: "end", color: "darkslategray" }}
                        >
                          {selectedLanguage === 'Marathi' ? 'एकूण' : 'Grand total'}: {calculateGrandTotal(orderData)}
                        </td>
                        <td
                          style={{ textAlign: "center", color: "white" }}
                        ></td>
                      </tr>
                    </tfoot>
                  </Table>
                </div>
              </div>
            ) : (
              //  ================== Employee & Customer table =================
              <div
                ref={componentRef}
                id="content-to-print"
                style={{ width: "100%" }}
              >
                <div style={{ overflowY: "auto" }}>
                  <div style={{ overflowX: "auto" }}>
                    <MDBDataTable
                      striped
                      className="custom-datatable"
                      bordered
                      hover
                      data={{
                        columns: [
                          {
                            label: (selectedLanguage === 'Marathi' ? 'अनु.क्र.' : 'Sr.No'),
                            field: "srNo",
                            sort: "asc",
                            style: {
                              alignItems: "center",
                              backgroundColor: "darkslategray",
                              fontSize: "13px",
                              fontFamily: "sans-serif",
                            },
                            className: "text-center text-light",
                          },
                          {
                            label:
                              selectedOption === "employee"
                                ? (selectedLanguage === 'Marathi' ? 'ग्राहकाचे नाव' : 'Customer Name')
                                : (selectedLanguage === 'Marathi' ? 'कर्मचारी नाव' : 'Employee Name'),
                            field: "customerOrEmployeeName",
                            sort: "asc",
                            style: {
                              alignItems: "center",
                              backgroundColor: "darkslategray",
                              fontSize: "13px",
                              fontFamily: "sans-serif",
                            },
                            className: "text-center text-light",
                          },
                          {
                            label: (selectedLanguage === 'Marathi' ? 'वितरण तपशील' : 'Delivery Detail'),
                            field: "deliveryDetail",
                            sort: "asc",
                            style: {
                              alignItems: "center",
                              backgroundColor: "darkslategray",
                              fontSize: "13px",
                              fontFamily: "sans-serif",
                            },
                            className: "text-center text-light",
                          },
                          {
                            label: (selectedLanguage === 'Marathi' ? 'एकूण रक्कम' : 'Total Amount'),
                            field: "totalAmount",
                            sort: "asc",
                            style: {
                              alignItems: "center",
                              backgroundColor: "darkslategray",
                              fontSize: "13px",
                              fontFamily: "sans-serif",
                            },
                            className: "text-center text-light",
                          },
                          {
                            label: (selectedLanguage === 'Marathi' ? 'तपशील' : 'Detail'),
                            field: "detail",
                            sort: "asc",
                            style: {
                              alignItems: "center",
                              backgroundColor: "darkslategray",
                              fontSize: "13px",
                              fontFamily: "sans-serif",
                            },
                            className: "text-center text-light",
                          },
                        ],
                        rows: groupedArray1.map((group, index) => ({
                          srNo: index + 1,
                          customerOrEmployeeName:
                            selectedOption === "employee"
                              ? group.customer_name
                              : group.employee_name,
                          deliveryDetail: group.items.map((item, i) => (
                            <div key={i}>
                              {`${item.product} - Rs(${item.rate})-${item.quantity}`}
                              {i < group.items.length - 1 ? "," : ""}
                            </div>
                          )),
                          totalAmount: group.items.reduce(
                            (sum, item) => sum + parseInt(item.total),
                            0
                          ),
                          detail: (
                            <i
                              className="fa-solid fa-circle-info"
                              onClick={() => handleShow(group)}
                            ></i>
                          ),
                        })),
                      }}
                    />
                  </div>
                </div>

                <Row className="m-0 p-0">
                  {dataShown && (
                    <Col style={{ display: "flex", justifyContent: "center" }}>
                      <Button
                        style={{
                          backgroundColor: "rgb(47, 79, 79)",
                          borderRadius: "15px",
                          border: "0px",
                        }}
                        className="buttonAll py-2 px-3 mx-2 my-3 shadow text-light"
                        type="submit"
                        onClick={generatePDF}
                        disabled={loading}
                      >
                        {loading ? (
                          <Spinner
                            animation="border"
                            size="sm"
                            variant="primary"
                          />
                        ) : (
                          <div>{selectedLanguage === 'Marathi' ? 'बिल तयार करा' : 'Generate Bill'}</div>
                        )}
                      </Button>
                    </Col>
                  )}
                </Row>
              </div>
            )}
          </Col>
        </Row>

        {/* ========================== Modal ============= */}
        <Modal
          className="shadow rounded"
          size="xl"
          show={show}
          onHide={handleClose}
        >
          <Modal.Header
            className="m-0 p-0 ps-3 text-center"
            style={{ backgroundColor: "rgb(214, 234, 248)", color: "black" }}
          >
            <Modal.Title>
              <div
                className="text-center mt-2"
                style={{
                  fontSize: "15px",
                }}
              >
                {selectedOption === "employee" ? (
                  <p>
                    <b>{selectedLanguage === 'Marathi' ? 'ग्राहक तपशील' : 'Customer Detail'}</b>
                  </p>
                ) : selectedOption === "all" ? (
                  <p>
                    <b>{selectedLanguage === 'Marathi' ? 'सर्व तपशील' : 'All Detail'}</b>
                  </p>
                ) : (
                  <p>
                    <b>{selectedLanguage === 'Marathi' ? 'कर्मचारी तपशील' : 'Employee Detail'}</b>
                  </p>
                )}
              </div>
            </Modal.Title>
          </Modal.Header>

          <Modal.Body className="m-0 p-0">
            <Form encType="multipart/form-data">
              <Row className="m-0">
                <div
                  ref={componentRef}
                  id="content-to-print"
                  style={{ width: "100%" }}
                >
                  <div className="px-5" style={{ overflowY: "auto" }}>
                    <div style={{ overflowX: "auto" }}>
                      <div
                        className=" mt-4"
                        style={{
                          fontSize: "15px",
                          display: "flex",
                        }}
                      >
                        {selectedOption === "employee" && (
                          <>
                            <p>
                              <b>{selectedLanguage === 'Marathi' ? 'ग्राहकाचे नाव' : 'Customer Name'}</b> -{" "}
                              {orderDataInner[0]?.customer_name}{" "}
                            </p>
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <p>
                              <b>{selectedLanguage === 'Marathi' ? 'कर्मचारी नाव' : 'Employee Name'}</b> - {orderDataInner[0]?.name}
                            </p>
                          </>
                        )}
                        {selectedOption === "customer" && (
                          <>
                            <p>
                              <b>{selectedLanguage === 'Marathi' ? 'ग्राहकाचे नाव' : 'Customer Name'}</b> -{" "}
                              {orderDataInner[0]?.customer_name}{" "}
                            </p>
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <p>
                              <b>{selectedLanguage === 'Marathi' ? 'कर्मचारी नाव' : 'Employee Name'}</b> - {orderDataInner[0]?.name}
                            </p>
                          </>
                        )}
                        {selectedOption === "all" && (
                          <>
                            <p>
                              <b>{selectedLanguage === 'Marathi' ? 'ग्राहकाचे नाव' : 'Customer Name'}</b> -{" "}
                              {orderDataInner[0]?.customer_name}{" "}
                            </p>
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <p>
                              <b>{selectedLanguage === 'Marathi' ? 'कर्मचारी नाव' : 'Employee Name'}</b> - {orderDataInner[0]?.name}
                            </p>
                          </>
                        )}
                      </div>

                      <Table
                        striped
                        bordered
                        hover
                        size="sm"
                        className="shadow mt-1"
                        style={{ textAlign: "center" }}
                      >
                        <thead>
                          <tr>
                            <th
                              style={{
                                alignItems: "center",
                                backgroundColor: "darkslategray",
                                fontSize: "13px",
                                fontFamily: "sans-serif",
                              }}
                              className="text-center text-light"
                            >
                              {selectedLanguage === 'Marathi' ? 'अनु.क्र.' : 'Sr.No'}
                            </th>
                            <th
                              style={{
                                alignItems: "center",
                                backgroundColor: "darkslategray",
                                fontSize: "13px",
                                fontFamily: "sans-serif",
                              }}
                              className="text-center text-light"
                            >
                              {selectedLanguage === 'Marathi' ? 'तारीख' : 'Date'}
                            </th>
                            <th
                              style={{
                                alignItems: "center",
                                backgroundColor: "darkslategray",
                                fontSize: "13px",
                                fontFamily: "sans-serif",
                              }}
                              className="text-center text-light"
                            >
                              {selectedLanguage === 'Marathi' ? 'उत्पादनाचे नांव' : 'Product Name'}
                            </th>
                            <th
                              style={{
                                alignItems: "end",
                                backgroundColor: "darkslategray",
                                fontSize: "13px",
                                fontFamily: "sans-serif",
                              }}
                              className="text-light"
                            >
                              {selectedLanguage === 'Marathi' ? 'संख्या' : 'Quantity'}
                            </th>
                            <th
                              style={{
                                alignItems: "end",
                                backgroundColor: "darkslategray",
                                fontSize: "13px",
                                fontFamily: "sans-serif",
                              }}
                              className="text-light"
                            >
                              {selectedLanguage === 'Marathi' ? 'दर' : 'Rate'}
                            </th>
                            <th
                              style={{
                                alignItems: "end",
                                backgroundColor: "darkslategray",
                                fontSize: "13px",
                                fontFamily: "sans-serif",
                              }}
                              className="text-light"
                            >
                              {selectedLanguage === 'Marathi' ? 'एकूण' : 'Total'}
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {orderDataInner.map((item, index) => (
                            <tr className="border" key={index}>
                              <td style={{ textAlign: "center" }}>
                                {index + 1}
                              </td>
                              <td style={{ textAlign: "center" }}>
                                {item.date}
                              </td>
                              {/* <td style={{ textAlign: 'center' }}>{item.product_name}</td> */}
                              <td style={{ textAlign: "center" }}>
                                {item.product_name}
                              </td>
                              <td className="pe-4" style={{ textAlign: "end" }}>
                                {item.quantity}
                              </td>
                              <td className="pe-4" style={{ textAlign: "end" }}>
                                {item.rate}
                              </td>
                              <td className="pe-4" style={{ textAlign: "end" }}>
                                {item.total}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                        <tfoot>
                          <tr>
                            <td
                              className="pe-4"
                              style={{
                                textAlign: "end",
                                color: "darkslategray",
                              }}
                              colSpan="3"
                            ></td>
                            <td
                              className="pe-4"
                              style={{
                                textAlign: "end",
                                color: "darkslategray",
                              }}
                            >
                             {selectedLanguage === 'Marathi' ? 'एकूण संख्या' : 'Total Quantity'}:{" "}
                              {selectedOption === "all"
                                ? calculateTotalQuantity1(orderDataInner)
                                : calculateTotalQuantity(orderDataInner)}
                            </td>
                            <td
                              className="pe-4"
                              style={{
                                textAlign: "end",
                                color: "darkslategray",
                              }}
                            ></td>
                            <td
                              className="pe-4"
                              style={{
                                textAlign: "end",
                                color: "darkslategray",
                              }}
                            >
                              {selectedLanguage === 'Marathi' ? 'एकूण' : 'Grand total'}:{" "}:{" "}
                              {orderDataInner.reduce(
                                (total, item) => total + parseFloat(item.total),
                                0
                              )}
                            </td>
                          </tr>
                        </tfoot>
                      </Table>
                    </div>
                  </div>
                </div>
              </Row>
            </Form>
          </Modal.Body>

          <Modal.Footer
            className="m-0 p-0"
            style={{ backgroundColor: "rgb(214, 234, 248)", color: "black" }}
          >
            <Button
              className="buttonAll px-4"
              style={{
                color: "white",
                backgroundColor: "darkslategray",
                border: "0px",
                borderRadius: "15px",
              }}
              onClick={handlePrint}
            >
               {selectedLanguage === 'Marathi' ? 'प्रिंट' : 'Print'}
            </Button>
            <Button
              style={{
                color: "black",
                backgroundColor: "white",
                border: "2px solid darkslategray",
                borderRadius: "15px",
              }}
              onClick={handleClose}
            >
       {selectedLanguage === 'Marathi' ? 'रद्द करा' : 'Cancel'} 
            </Button>
          </Modal.Footer>
        </Modal>

        <div>
          <div id="pdf-content" style={{ display: "none" }}>
            <div
              className="row m-0 p-0"
              style={{ display: "flex", flexDirection: "row" }}
            >
              {data.map((item, index) => (
                <React.Fragment key={index}>
                  {/* First Bill */}
                  <div
                    style={{
                      width: "382.4px",
                      height: "547.01px",
                      margin: "7.015px",
                    }}
                    className="border"
                  >
                    <div style={{ lineHeight: "15px" }}>
                      <div className="text-center pt-3">
                        <p style={{ fontSize: "18px" }}>
                          <b>{BrName}</b>
                        </p>
                      </div>
                      <div className="text-center">
                        <p style={{ fontSize: "13px" }}>
                          <b>{selectedLanguage === 'Marathi' ? 'फोन' : 'Phone'} </b> : 8208256339
                        </p>
                      </div>
                      <div className="row pt-3">
                        <div className="text-start col-6">
                          <p style={{ fontSize: "13px" }}>
                            <b>{selectedLanguage === 'Marathi' ? 'तारीख' : 'Date'} </b> : {item.bill_date}
                          </p>
                        </div>
                        <div className="text-end pe-4 col-6">
                          <p style={{ fontSize: "13px" }}>
                            <b>{selectedLanguage === 'Marathi' ? 'बिल क्र' : 'Bill No'} </b> : {item.bill_no}
                          </p>
                        </div>
                      </div>
                      <div>
                        <p style={{ fontSize: "13px" }}>
                          <b>{selectedLanguage === 'Marathi' ? 'ग्राहक. नाव' : 'Cust. Name'} </b> : {item.customer_name}
                        </p>
                      </div>
                      <div>
                        <p style={{ fontSize: "13px" }}>
                          <b>{selectedLanguage === 'Marathi' ? 'कर्मचारी. नाव' : 'Emp. Name'} </b> : {item.employee_name}
                        </p>
                      </div>
                      <div>
                        <p style={{ fontSize: "13px" }}>
                          <b>{selectedLanguage === 'Marathi' ? 'महिना' : 'Month'} </b> : {item.month} {item.year}
                        </p>
                      </div>
                    </div>

                    <div style={{ height: "230px" }}>
                      <table
                        id="pdf-table"
                        style={{ borderCollapse: "collapse", width: "100% " }}
                      >
                        <thead style={{ fontSize: "12px" }}>
                          <tr>
                            <th
                              style={{
                                border: "1px solid #dddddd",
                                textAlign: "center",
                                padding: "8px",
                              }}
                            >
                              {selectedLanguage === 'Marathi' ? 'अनु.क्र.' : 'Sr.No'}
                            </th>
                            <th
                              style={{
                                border: "1px solid #dddddd",
                                textAlign: "center",
                                padding: "8px",
                              }}
                            >
                              {selectedLanguage === 'Marathi' ? 'उत्पादन' : 'Product'}
                            </th>
                            <th
                              style={{
                                border: "1px solid #dddddd",
                                textAlign: "center",
                                padding: "8px",
                              }}
                            >
                              {selectedLanguage === 'Marathi' ? 'संख्या' : 'Qty'}
                            </th>
                            <th
                              style={{
                                border: "1px solid #dddddd",
                                textAlign: "center",
                                padding: "8px",
                              }}
                            >
                              {selectedLanguage === 'Marathi' ? 'दर' : 'Rate'}
                            </th>
                            <th
                              style={{
                                border: "1px solid #dddddd",
                                textAlign: "center",
                                padding: "8px",
                              }}
                            >
                               {selectedLanguage === 'Marathi' ? 'एकूण' : 'Total'}
                            </th>
                          </tr>
                        </thead>
                        <tbody style={{ fontSize: "13px" }}>
                          {item.products.map((product, productIndex) => (
                            <tr key={productIndex}>
                              <td
                                style={{
                                  border: "1px solid #dddddd",
                                  textAlign: "center",
                                  padding: "8px",
                                }}
                              >
                                {productIndex + 1}
                              </td>
                              <td
                                style={{
                                  border: "1px solid #dddddd",
                                  textAlign: "center",
                                  padding: "8px",
                                }}
                              >
                                {product.product}
                              </td>
                              <td
                                className="pe-3"
                                style={{
                                  border: "1px solid #dddddd",
                                  textAlign: "end",
                                  padding: "8px",
                                }}
                              >
                                {product.quantity}
                              </td>
                              <td
                                style={{
                                  border: "1px solid #dddddd",
                                  textAlign: "center",
                                  padding: "8px",
                                }}
                              >
                                {product.rate}
                              </td>
                              <td
                                className="pe-3"
                                style={{
                                  border: "1px solid #dddddd",
                                  textAlign: "end",
                                  padding: "8px",
                                }}
                              >
                                {product.total}
                              </td>
                            </tr>
                          ))}
                          <tr>
                            <td
                              colSpan={3}
                              className="pe-3"
                              style={{
                                border: "1px solid #dddddd",
                                textAlign: "end",
                                padding: "8px",
                              }}
                            >
                              <b style={{ fontSize: "12px" }}>{selectedLanguage === 'Marathi' ? 'एकूण संख्या' : 'Total Qty'} = </b>{" "}
                              {item.products.reduce(
                                (acc, cur) => acc + cur.quantity,
                                0
                              )}
                            </td>
                            <td
                              colSpan={2}
                              className="pe-3"
                              style={{
                                border: "1px solid #dddddd",
                                textAlign: "end",
                                padding: "8px",
                              }}
                            >
                              <b style={{ fontSize: "12px" }}>{selectedLanguage === 'Marathi' ? 'निव्वळ रक्कम' : 'Net Amount'}=</b>{" "}
                              {item.products.reduce(
                                (acc, cur) => acc + cur.total,
                                0
                              )}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div className="row mt-4">
                      <div style={{ fontSize: "13px" }} className="col-5">
                        <b>{selectedLanguage === 'Marathi' ? 'शेवटची शिल्लक' : 'Last balance'}:</b> {item.extra_payamount}&nbsp;
                      </div>
                      <div style={{ fontSize: "13px" }} className="col-5">
                        <b>{selectedLanguage === 'Marathi' ? 'बिलाची रक्कम' : 'Bill Amount'}:</b>{" "}
                        {item.extra_payamount < 0
                          ? item.products.reduce(
                              (acc, cur) => acc + cur.total,
                              0
                            ) - Math.abs(item.extra_payamount)
                          : item.products.reduce(
                              (acc, cur) => acc + cur.total,
                              0
                            ) + item.extra_payamount}
                        &nbsp;
                      </div>
                      <div style={{ fontSize: "13px" }} className="col-2">
                        <b>{selectedLanguage === 'Marathi' ? 'सही ' : 'Sign'}</b>{" "}
                      </div>
                    </div>

                    <div className=" pt-4 ">
                      <p
                        style={{
                          fontSize: "11px",
                          display: "flex",
                          justifyContent: "start",
                        }}
                      >
                        <i>Developed by: TechnoAarv Solution </i>
                      </p>
                    </div>
                  </div>

                  {/* Second Bill */}
                  <div
                    style={{
                      width: "382.4px",
                      height: "547.01px",
                      margin: "7.015px",
                    }}
                    className="border"
                  >
                    <div style={{ lineHeight: "15px" }}>
                      <div className="text-center pt-3">
                        <p style={{ fontSize: "18px" }}>
                          <b>{BrName}</b>
                        </p>
                      </div>
                      <div className="text-center">
                        <p style={{ fontSize: "13px" }}>
                          <b>{selectedLanguage === 'Marathi' ? 'फोन' : 'Phone'}</b> : 8208256339
                        </p>
                      </div>
                      <div className="row pt-3">
                        <div className="text-start col-6">
                          <p style={{ fontSize: "13px" }}>
                            <b>{selectedLanguage === 'Marathi' ? 'तारीख' : 'Date'}</b> : {item.bill_date}
                          </p>
                        </div>
                        <div className="text-end pe-4 col-6">
                          <p style={{ fontSize: "13px" }}>
                            <b>{selectedLanguage === 'Marathi' ? 'बिल क्र' : 'Bill No'}</b>: {item.bill_no}
                          </p>
                        </div>
                      </div>
                      <div>
                        <p style={{ fontSize: "13px" }}>
                          <b>{selectedLanguage === 'Marathi' ? 'ग्राहक. नाव' : 'Cust. Name'} </b> : {item.customer_name}
                        </p>
                      </div>
                      <div>
                        <p style={{ fontSize: "13px" }}>
                          <b>{selectedLanguage === 'Marathi' ? 'कर्मचारी. नाव' : 'Emp. Name'} </b> : {item.employee_name}
                        </p>
                      </div>
                      <div>
                        <p style={{ fontSize: "13px" }}>
                          <b>{selectedLanguage === 'Marathi' ? 'महिना' : 'Month'} </b> : {item.month} {item.year}
                        </p>
                      </div>
                    </div>

                    <div style={{ height: "230px" }}>
                      <table
                        id="pdf-table"
                        style={{ borderCollapse: "collapse", width: "100% " }}
                      >
                        <thead style={{ fontSize: "12px" }}>
                          <tr>
                            <th
                              style={{
                                border: "1px solid #dddddd",
                                textAlign: "center",
                                padding: "8px",
                              }}
                            >
                              {selectedLanguage === 'Marathi' ? 'अनु.क्र.' : 'Sr.No'}
                            </th>
                            <th
                              style={{
                                border: "1px solid #dddddd",
                                textAlign: "center",
                                padding: "8px",
                              }}
                            >
                              {selectedLanguage === 'Marathi' ? 'उत्पादन' : 'Product'}
                            </th>
                            <th
                              style={{
                                border: "1px solid #dddddd",
                                textAlign: "center",
                                padding: "8px",
                              }}
                            >
                              {selectedLanguage === 'Marathi' ? 'संख्या' : 'Qty'}
                            </th>
                            <th
                              style={{
                                border: "1px solid #dddddd",
                                textAlign: "center",
                                padding: "8px",
                              }}
                            >
                              {selectedLanguage === 'Marathi' ? 'दर' : 'Rate'}
                            </th>
                            <th
                              style={{
                                border: "1px solid #dddddd",
                                textAlign: "center",
                                padding: "8px",
                              }}
                            >
                               {selectedLanguage === 'Marathi' ? 'एकूण' : 'Total'}
                            </th>
                          </tr>
                        </thead>
                        <tbody style={{ fontSize: "13px" }}>
                          {item.products.map((product, productIndex) => (
                            <tr key={productIndex}>
                              <td
                                style={{
                                  border: "1px solid #dddddd",
                                  textAlign: "center",
                                  padding: "8px",
                                }}
                              >
                                {productIndex + 1}
                              </td>
                              <td
                                style={{
                                  border: "1px solid #dddddd",
                                  textAlign: "center",
                                  padding: "8px",
                                }}
                              >
                                {product.product}
                              </td>
                              <td
                                className="pe-3"
                                style={{
                                  border: "1px solid #dddddd",
                                  textAlign: "end",
                                  padding: "8px",
                                }}
                              >
                                {product.quantity}
                              </td>
                              <td
                                style={{
                                  border: "1px solid #dddddd",
                                  textAlign: "center",
                                  padding: "8px",
                                }}
                              >
                                {product.rate}
                              </td>
                              <td
                                className="pe-3"
                                style={{
                                  border: "1px solid #dddddd",
                                  textAlign: "end",
                                  padding: "8px",
                                }}
                              >
                                {product.total}
                              </td>
                            </tr>
                          ))}
                          <tr>
                            <td
                              colSpan={3}
                              className="pe-3"
                              style={{
                                border: "1px solid #dddddd",
                                textAlign: "end",
                                padding: "8px",
                              }}
                            >
                              <b style={{ fontSize: "12px" }}>{selectedLanguage === 'Marathi' ? 'एकूण संख्या' : 'Total Qty'} = </b>{" "}
                              {item.products.reduce(
                                (acc, cur) => acc + cur.quantity,
                                0
                              )}
                            </td>
                            <td
                              colSpan={2}
                              className="pe-3"
                              style={{
                                border: "1px solid #dddddd",
                                textAlign: "end",
                                padding: "8px",
                              }}
                            >
                              <b style={{ fontSize: "12px" }}>{selectedLanguage === 'Marathi' ? 'निव्वळ रक्कम' : 'Net Amount'}=</b>{" "}
                              {item.products.reduce(
                                (acc, cur) => acc + cur.total,
                                0
                              )}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div className="row mt-4">
                      <div style={{ fontSize: "13px" }} className="col-5">
                        <b>{selectedLanguage === 'Marathi' ? 'शेवटची शिल्लक' : 'Last balance'}:</b> {item.extra_payamount}&nbsp;
                      </div>
                      <div style={{ fontSize: "13px" }} className="col-5">
                        <b>{selectedLanguage === 'Marathi' ? 'बिलाची रक्कम' : 'Bill Amount'}:</b>{" "}
                        {item.extra_payamount < 0
                          ? item.products.reduce(
                              (acc, cur) => acc + cur.total,
                              0
                            ) - Math.abs(item.extra_payamount)
                          : item.products.reduce(
                              (acc, cur) => acc + cur.total,
                              0
                            ) + item.extra_payamount}
                        &nbsp;
                      </div>
                      <div style={{ fontSize: "13px" }} className="col-2">
                        <b>{selectedLanguage === 'Marathi' ? 'सही ' : 'Sign'}</b>{" "}
                      </div>
                    </div>

                    <div className=" pt-4 ">
                      <p
                        style={{
                          fontSize: "11px",
                          display: "flex",
                          justifyContent: "start",
                        }}
                      >
                        <i>Developed by: TechnoAarv Solution </i>
                      </p>
                    </div>
                  </div>
                </React.Fragment>
              ))}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default BillingProcess1;
